_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
Card = require 'app/scripts/models/card'
Controller = require 'app/scripts/controller'
Board = require 'app/scripts/models/board'
List = require 'app/scripts/models/list'
Member = require 'app/scripts/models/member'
{ Plugin } = require 'app/scripts/models/Plugin'
Promise = require 'bluebird'
makeErrorEnum = require 'app/scripts/lib/make-error-enum'
ModelCache = require 'app/scripts/db/model-cache'
xtend = require 'xtend'

PluginHandlerContextError = makeErrorEnum 'PluginHandlerContext', [
  'InvalidType'
  'NotSerializable'
  'PluginDisabled'
]

elMap = {}

isCurrentBoard = (idBoard) ->
  (board = Controller.getCurrentBoard())? && board.id == idBoard

alphabet = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWYXZ"

randomId = (length = 16) ->
  digits = []
  for i in [0...length]
    digits.push(alphabet[Math.floor(Math.random() * alphabet.length)])
  digits.join('')

handlers = {}

# We have to be able to convert a context object into something we can send
# over postMessage; there are a few special keys that contain complex objects
# that we know how to serialize
converters =
  card:
    type: Card
    serialize: (card) ->
      value: card.id
    deserialize: (idCard) ->
      requestedCard = ModelCache.get('Card', idCard)
      if requestedCard? && isCurrentBoard(requestedCard.get('idBoard'))
        requestedCard
      else
        null

  board:
    type: Board
    serialize: (board) ->
      value: board.id
    deserialize: (idBoard) ->
      if isCurrentBoard(idBoard)
        ModelCache.get('Board', idBoard)
      else
        null

  list:
    type: List
    serialize: (list) ->
      value: list.id
    deserialize: (idList) ->
      requestedList = ModelCache.get('List', idList)
      if requestedList? && isCurrentBoard(requestedList.get('idBoard'))
        requestedList
      else
        null

  member:
    type: Member
    serialize: (member) ->
      value: member.id
    deserialize: (idMember) ->
      if Auth.isMe(idMember)
        ModelCache.get('Member', idMember)
      else
        null

  el:
    type: Element
    serialize: (element) ->
      ref = randomId()
      elMap[ref] = element

      value: ref
      disposer: ->
        delete elMap[ref]
    deserialize: (ref) ->
      elMap[ref]

isSerializable = (obj) ->
  if _.isString(obj) || _.isNumber(obj) || _.isBoolean(obj) || _.isNull(obj) || _.isUndefined(obj)
    true
  else if _.isFunction(obj) || _.isRegExp(obj) || _.isDate(obj)
    false
  else if _.isArray(obj)
    _.every obj, isSerializable
  else if _.isObject(obj)
    isSerializable _.values(obj)
  else
    false

serialize = (context) ->
  disposers = []

  Promise.try ->
    _.mapObject context, (value, key) ->
      if (converter = converters[key])?
        if !(value instanceof converter.type)
          if !value?
            return null

          throw PluginHandlerContextError.InvalidType("value in context did not have the expected type")

        { value: serialized, disposer } = converter.serialize(value)
        if disposer?
          disposers.push(disposer)
        serialized
      else if isSerializable(value)
        value
      else
        throw PluginHandlerContextError.NotSerializable("the value for #{ key } was not serializable")
  .disposer ->
    for disposer in disposers
      disposer()
    return

deserialize = (serialized, idPlugin) ->
  deserialized = _.mapObject serialized, (value, key) ->
    if value? && converters.hasOwnProperty(key) && (converter = converters[key])?
      converter.deserialize(value)
    else
      value
  if !(deserialized.board || Controller.getCurrentBoard())?.isPluginEnabled(idPlugin)
    throw PluginHandlerContextError.PluginDisabled("plugin disabled on board idPlugin=#{idPlugin}")

  return deserialized

extend = (contexts...) -> xtend(contexts...)

module.exports =
  Error: PluginHandlerContextError
  serialize: serialize
  deserialize: deserialize
  extend: extend
